"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * A function that returns a comma separated string with optional values of userId and browserCookieId. It's used for
 * the header Correlation-Context value
 */
var calculateClientSideCorrelationContext = function (userId, browserCookieId) {
    var correlationContext = browserCookieId ? "browserCookieId=" + browserCookieId : '';
    if (userId) {
        correlationContext = correlationContext ? correlationContext + ",userId=" + userId : "userId=" + userId;
    }
    return correlationContext;
};
exports.default = calculateClientSideCorrelationContext;
//# sourceMappingURL=calculateClientSideCorrelationContext.js.map